'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSignals$0024 from "./presto.-Signals$.js";
var $p;
/** @constructor */
function $c_Lpresto_Mediator$$anon$18(request$2, bus$2, results$2, busy$4, tmp$2, outer) {
  this.b7J = null;
  this.b7I = null;
  this.a8w = null;
  this.a8v = null;
  this.b7K = null;
  this.b7J = request$2;
  this.b7I = bus$2;
  this.a8w = results$2;
  this.a8v = busy$4;
  this.b7K = tmp$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_Mediator$$anon$18 as $c_Lpresto_Mediator$$anon$18 };
$p = $c_Lpresto_Mediator$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Mediator$$anon$18;
/** @constructor */
function $h_Lpresto_Mediator$$anon$18() {
}
export { $h_Lpresto_Mediator$$anon$18 as $h_Lpresto_Mediator$$anon$18 };
$h_Lpresto_Mediator$$anon$18.prototype = $p;
$p.afO = (function() {
  return this.b7I.bp;
});
$p.a3G = (function() {
  return this.a8w.br;
});
$p.afW = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_Implicits$RichSource$().bb(this.b7K, this.a8w);
});
$p.act = (function() {
  return $j_presto$002e$002dSignals$0024.$m_Lpresto_Signals$().oT(this.a8v, this.b7J, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction2(((_$11, _$12) => ((!(!_$11)) || _$12.mj()))));
});
$p.A6 = (function() {
  return this.a8v.R();
});
$p.cPX = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a3G(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$13) => _$13.db())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cMA = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cPX(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$14) => (!_$14.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => _$15.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.cEf = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.a3G(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$16) => _$16.cwg().cQ1().db())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
$p.aeD = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_FilterStream(this.cEf(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$17) => (!_$17.k())))), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$18) => _$18.q())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
});
var $d_Lpresto_Mediator$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Mediator$$anon$18, "presto.Mediator$$anon$18", ({
  Mr: 1,
  Ms: 1
}));
export { $d_Lpresto_Mediator$$anon$18 as $d_Lpresto_Mediator$$anon$18 };
//# sourceMappingURL=presto.-Mediator$$anon$18.js.map
